export const CASH_UPS_FETCH_REQUEST = 'CASH_UPS_FETCH_REQUEST'
export const CASH_UPS_FETCH_SUCCESS = 'CASH_UPS_FETCH_SUCCESS'
export const CASH_UPS_FETCH_FAILURE = 'CASH_UPS_FETCH_FAILURE'

export const CASH_UPS_SAVE_REQUEST = 'CASH_UPS_SAVE_REQUEST'
export const CASH_UPS_SAVE_SUCCESS = 'CASH_UPS_SAVE_SUCCESS'
export const CASH_UPS_SAVE_FAILURE = 'CASH_UPS_SAVE_FAILURE'

export const EMPTY_CASH_UPS = 'EMPTY_CASH_UPS'
export const CLEAR_ERRORS = 'CLEAR_ERRORS'